import {
  EDU_EVENT_APP_NAME,
  EDU_EVENT_ORIGINAL_EMITTER,
} from '../constants/tagular';

export type HeaderServiceTrackedEvent = {
  'X-Powered-By': string;
  'X-RVEDU-Request-Chain-Id': string;
  'X-RVEDU-Original-Emitter': string;
  'X-RVEDU-Session-ID': string;
  'X-RVEDU-Anonymous-ID': string;
  'X-RVEDU-Referer': string;
};

export const createServiceTrackedHeaders = (
  requestChainId: string,
): HeaderServiceTrackedEvent => {
  return {
    'X-Powered-By': EDU_EVENT_APP_NAME,
    'X-RVEDU-Request-Chain-Id': requestChainId,
    'X-RVEDU-Original-Emitter': EDU_EVENT_ORIGINAL_EMITTER,
    'X-RVEDU-Session-ID': window?.tagular?.('getAliasSet')?.sessionId || '',
    'X-RVEDU-Anonymous-ID': window?.tagular?.('getAliasSet')?.anonymousId || '',
    'X-RVEDU-Referer': window.location.href || '',
  };
};
